module.exports = __webpack_public_path__ + "f09b54896648f253664d2c5df607133a.jpg";